import CustomButton from 'common/components/CustomButton';
import CalendarType from 'common/enums/calendarTypes';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { openNestedDialog } from 'redux/slices/nestedDialogSlice';
import MyAvailabilityCreate from './myAvailabilityForm/MyAvailabilityCreate';

const MyAvailabilityCreateAction = ({ userData }) => {
    const dispatch = useDispatch();
    const { t } = useTranslation();

    const handleCreateClick = () => {
        dispatch(openNestedDialog(<MyAvailabilityCreate userData={userData} type={CalendarType.AGENT} />));
    };

    return (
        <CustomButton onClick={handleCreateClick}>
            <span>{t('availability.createAction.add')}</span>
        </CustomButton>
    );
};

export default MyAvailabilityCreateAction;
